import { useState } from "react";
import ModalEditSelect2 from "../../../../components/modal/modalEditSelect2";
import { useParams } from "react-router-dom";
import { detailTrainingTel1Change, detailTrainingTel1Unlink } from "../../../../config/apiSPA";
import ModalInfo from "../../../../components/modal/modalInfo";
import ModalConfirm from "../../../../components/modal/modalConfirm";
import Tel1ToPdf from "../../../../components/pdfGenerator/Tel1/Tel1ToPdf";
const selectModalInitalState = {
  show: false,
  options: {
    title: "",
    text: "",
  },
  id: null,
  selector: "",
  selected: null,
  event: "",
};
const infoModalInitialState = {
  show: false,
  title: "",
  text: "",
  theme: "",
};
const confirmModalInitialState = {
  show: false,
  title: "",
  text: "",
  actionType: "",
  theme: "",
  id: null,
};
function TrainingEvaluasiLvl1Toolbar({ onUpdate = () => {}, isFound = false }) {
  const { id } = useParams();

  const [selectModalState, setSelectModalState] = useState(selectModalInitalState);
  const [infoModalState, setInfoModalState] = useState(infoModalInitialState);
  const [confirmModalState, setConfirmModalState] = useState(confirmModalInitialState);
  const [loadingBtnExportStatus, setLoadingBtnStatus] = useState(false);
  const handleClickAddTel1 = () => {
    setSelectModalState({
      show: true,
      options: {
        title: "Add Training Evaluation Lvl. 1",
        text: "Please select training evaluation lavel 1",
      },
      id: id,
      selector: "tel1-event-list",
      selected: null,
      event: "submitTel1",
    });
  };
  const handleClickChangeTel1 = () => {
    setSelectModalState({
      show: true,
      options: {
        title: "Change Training Evaluation Lvl. 1",
        text: "Please select training evaluation lavel 1",
      },
      id: id,
      selector: "tel1-event-list",
      selected: null,
      event: "submitTel1",
    });
  };
  const handleSubmitSelectModal = async (e, event) => {
    setSelectModalState(selectModalInitalState);
    try {
      const payload = {
        trainingId: e.id,
        tel1EventId: e.val,
      };
      const res = await detailTrainingTel1Change(payload);
      onUpdate({
        success: true,
        data: res.data,
      });
    } catch (error) {
      setInfoModalState({
        show: true,
        title: "Failed",
        text: "Something went wrong while adding TEL1. Please try again.",
        theme: "danger",
      });
    }
  };
  const handleClickUnlinkTel1 = () => {
    setConfirmModalState({
      show: true,
      title: "Warning !!",
      text: "Are you sure want to unlink Tel1 from this event training?",
      actionType: "unlinkTel1",
      theme: "danger",
      id: id,
    });
  };
  const handleClickConfirmModal = async (e) => {
    setConfirmModalState(confirmModalInitialState);
    try {
      const res = await detailTrainingTel1Unlink({ trainingId: e });
    } catch (error) {
      onUpdate({
        success: false,
        message: error,
      });
    }
  };
  const handleClickExportTel1Form = async () => {
    setLoadingBtnStatus(true);
    setLoadingBtnStatus(await Tel1ToPdf(id));
  };
  return (
    <>
      {isFound ? (
        <div className="mb-2">
          <div className="d-block d-lg-flex align-items-center">
            <span onClick={handleClickChangeTel1} className="btn btn-outline-theme me-2">
              <i className="fas fa-sync"></i>
              <span>Change</span>
            </span>
            {loadingBtnExportStatus ? (
              <div className="spinner-border me-2"></div>
            ) : (
              <span onClick={handleClickExportTel1Form} className="btn btn-outline-theme me-2">
                <i className="fas fa-file-pdf"></i>
                <span>Export</span>
              </span>
            )}

            <span onClick={handleClickUnlinkTel1} className="btn btn-outline-danger me-2">
              <i className="fas fa-unlink"></i>
              <span>Unlink</span>
            </span>
          </div>
        </div>
      ) : (
        <div className="mb-2">
          <div className="alert alert-warning mb-3">Training Evaluation Level 1 was not found. Please link the training to an existing Level 1 Evaluation event by clicking "Add Tel1" and selecting an event from the list.</div>
          <div className="d-block d-lg-flex align-items-center">
            <span onClick={handleClickAddTel1} className="btn btn-outline-theme me-2 mb-1">
              <i className="fa fa-fw fa-plus"></i>
              <span>Add Tel1</span>
            </span>
          </div>
        </div>
      )}
      <ModalEditSelect2
        show={selectModalState.show}
        onHide={() => setSelectModalState(selectModalInitalState)}
        id={selectModalState.id}
        selector={selectModalState.selector}
        selected={selectModalState.selected}
        options={selectModalState.options}
        submitClick={(e) => handleSubmitSelectModal(e, selectModalState.event)}
      />
      <ModalInfo
        show={infoModalState.show}
        title={infoModalState.title}
        text={infoModalState.text}
        theme={infoModalState.theme}
        onHide={() => setInfoModalState(infoModalInitialState)}
        clicked={() => setInfoModalState(infoModalInitialState)}
      />
      <ModalConfirm
        show={confirmModalState.show}
        title={confirmModalState.title}
        text={confirmModalState.text}
        theme={confirmModalState.theme}
        id={confirmModalState.id}
        onHide={() => setConfirmModalState(confirmModalInitialState)}
        actionType={confirmModalState.actionType}
        clicked={(e) => handleClickConfirmModal(e)}
      />
    </>
  );
}

export default TrainingEvaluasiLvl1Toolbar;
